import { Model } from "#/shared/models/model.js";

export class Result extends Model {
  constructor(data) {
    super(data ?? {});
  }
}
